import { CategoryItemType } from "../models/category";

export const CategoryLabels: Record<CategoryItemType, string> = {
  STANDARD: "Standard",
  MEAL: "Restauration",
  HOUSING: "Logement",
  TRAVEL: "Déplacement",
  OFFICE: "Bureau",
  TRAINING: "Formation",
  PROVIDER: "Fournisseur",
  VEHICLE: "Véhicule",
  EQUIPMENT: "Équipement",
  FUEL: "Carburant",
  PHONE: "Téléphonie",
  PRESSING: "Pressing",
  OTHER: "Autre"
};